import { render, staticRenderFns } from "./UserIntro.vue?vue&type=template&id=f56c034a&scoped=true&"
import script from "./UserIntro.vue?vue&type=script&lang=js&"
export * from "./UserIntro.vue?vue&type=script&lang=js&"
import style0 from "./UserIntro.vue?vue&type=style&index=0&id=f56c034a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56c034a",
  null
  
)

export default component.exports